import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

/**
 * Опции для выбора решения об исполнении соглашения
 */
export const successExecutionSelectOptions: ISelectOption<number> = {
  id: 1,
  label: 'Признать соглашение исполненным',
  value: true,
};

export const failExecutionSelectOptions: ISelectOption<number> = {
  id: 2,
  label: 'Признать соглашение неисполненным',
  value: false,
};
